export default __webpack_public_path__ + "static/media/text-logo.76aa5780.png";